<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</template>

<script>
export default {
   mounted () {
        console.log("About montad");
    },
}
</script>
<style lang="">
  
</style>
